var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',{staticClass:"my-1",attrs:{"vs-align":"center"}},[_c('vs-col',{attrs:{"vs-w":"2"}},[_c('vs-row',{staticClass:"pr-4",attrs:{"vs-justify":"flex-end","vs-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.title))])])],1),_c('vs-col',{attrs:{"vs-w":"10"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }